import React from 'react';
import { applyTypography } from '@repo/common';

const ThingsToKnowSection = ({ content = '' }) => {
  return (
    <div className='flex flex-col items-start relative shrink-0 w-full'>
      <div className='bg-grayscale-gray00 flex flex-col gap-[8px] items-start not-italic px-[24px] py-[30px] relative shadow-3 shrink-0 w-full tabletH:gap-[16px] tabletH:rounded-[50px] tabletH:pb-[80px] tabletH:pt-[60px] tabletH:px-[80px]'>
        <p
          className={`${applyTypography('b18Strong')} tabletH:${applyTypography(
            'title1',
          )} text-text-primary shrink-0 leading-[1.5] tabletH:leading-[1.2]`}
        >
          Things to know
        </p>
        <p
          className={`${applyTypography('b14')} tabletH:${applyTypography(
            'b16',
          )} text-text-tertiary min-w-full shrink-0 w-[min-content] whitespace-pre-wrap leading-[1.4] tabletH:leading-[1.5]`}
        >
          {content || 'text text text...'}
        </p>
      </div>
    </div>
  );
};

export default ThingsToKnowSection;
